module.exports = __webpack_public_path__ + "static/img/manual_zh_29.88a50cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_29.png
// module id = 9pgu
// module chunks = 4